<widget-header
  [name]="widgetName"
  [editable]="isEditable">

  <attribute-help-text slot="prepend"
    attribute="description"
  [attributeScope]="'Project'" />

  <widget-menu slot="menu"
    [resource]="resource" />
</widget-header>

<div class="op-widget-box--body -allow-inner-overflow">
  @if ((project$ | async); as project) {
    <edit-form
      [resource]="project">
      <op-editable-attribute-field [resource]="project"
        fieldName="description" />
    </edit-form>
  }
</div>
